import { CIcon } from '~/icons/types'
import { CategoryId } from '~/models/category/types'

// Thin icons
import { ciBicycles } from '~/icons/source/thin/bicycles'
import { ciMotorbikes } from '~/icons/source/thin/motorbikes'
import { ciBoats } from '~/icons/source/thin/boats'
import { ciBuilders } from '~/icons/source/thin/builders'
import { ciBuses } from '~/icons/source/thin/buses'
import { ciCars } from '~/icons/source/thin/cars'
import { ciCaravans } from '~/icons/source/thin/caravans'
import { ciContainers } from '~/icons/source/thin/containers'
import { ciForklifts } from '~/icons/source/thin/forklifts'
import { ciGokarts } from '~/icons/source/thin/gokarts'
import { ciJobs } from '~/icons/source/thin/jobs'
import { ciMotorhomes } from '~/icons/source/thin/motorhomes'
import { ciRealEstate } from '~/icons/source/thin/real-estate'
import { ciRentals } from '~/icons/source/thin/rentals'
import { ciSemitrucks } from '~/icons/source/thin/semitrucks'
import { ciSemitrailers } from '~/icons/source/thin/semitrailers'
import { ciSnowsports } from '~/icons/source/thin/snowsports'
import { ciTaxis } from '~/icons/source/thin/taxis'
import { ciTractors } from '~/icons/source/thin/tractors'
import { ciTrailers } from '~/icons/source/thin/trailers'
import { ciTrucks } from '~/icons/source/thin/trucks'
import { ciVans } from '~/icons/source/thin/vans'
import { ciWantedParts } from '~/icons/source/thin/wanted-parts'
import { ciWatersports } from '~/icons/source/thin/watersports'
import { ciVehicles } from '~/icons/source/thin/vehicles'
import { ciDeals } from '~/icons/source/thin/deals'
import { ciCarService } from '~/icons/source/thin/car-service'
import { ciCatamaran } from '~/icons/source/thin/catamaran'
import { ciYacht } from '~/icons/source/thin/yacht'
import { ciJetSki } from '~/icons/source/thin/jet-ski'
import { ciBoatParking } from '~/icons/source/thin/boat-parking'
import { ciFishingBoat } from '~/icons/source/thin/fishing-boat'
import { ciSailboat } from '~/icons/source/thin/sailboat'
import { ciBoatInflatableRib } from '~/icons/source/thin/boat-inflatable-rib'
import { ciBoatTrailer } from '~/icons/source/thin/boat-trailer'
import { ciBoatTourist } from '~/icons/source/thin/boat-tourist'
import { ciBoatFerry } from '~/icons/source/thin/boat-ferry'
import { ciBoatRow } from '~/icons/source/thin/boat-row'
import { ciBoatTug } from '~/icons/source/thin/boat-tug'
import { ciCabinBoat } from '~/icons/source/thin/cabin-boat'
import { ciCanoeKayak } from '~/icons/source/thin/canoe-kayak'
import { ciBoatEngines } from '~/icons/source/thin/boat-engines'
import { ciBoatLicenses } from '~/icons/source/thin/boat-licenses'
import { ciBoatOpen } from '~/icons/source/thin/boat-open'
import { ciSpeedboat } from '~/icons/source/thin/speedboat'
import { ciLoadShipper } from '~/icons/source/thin/load-shipper'
import { ciThreeDots } from '~/icons/source/thin/three-dots'
import { ciToolsAccessories } from '~/icons/source/thin/tools-accessories'
import { ciMassCateringEquipment } from '~/icons/source/thin/mass-catering-equipment'
import { ciHealthBeautyMedicine } from '~/icons/source/thin/health-beauty-medicine'
import { ciBusinessEquipment } from '~/icons/source/thin/business-equipment'
import { ciAntiques } from '~/icons/source/thin/antiques'
import { ciHobbySports } from '~/icons/source/thin/hobby-sports'
import { ciTechnologySecurity } from '~/icons/source/thin/technology-security'
import { ciHouseGarden } from '~/icons/source/thin/house-garden'
import { ciFashion } from '~/icons/source/thin/fashion'
import { ciChildrenGoods } from '~/icons/source/thin/children-goods'
import { ciSupermarket } from '~/icons/source/thin/supermarket'
import { ciSale } from '~/icons/source/thin/sale'
import { ciRent } from '~/icons/source/thin/rent'
import { ciBooking } from '~/icons/source/thin/booking'
import { ciWantedProperty } from '~/icons/source/thin/wanted-property'
import { ciPetsAnimals } from '~/icons/source/thin/pets-animals'
import { ciPartsAccessories } from '~/icons/source/thin/parts-accessories'
import { ciMarketplace } from '~/icons/source/thin/marketplace'
import { ciWheelLoaders } from '~/icons/source/thin/wheel-loaders'
import { ciHobbies } from '~/icons/source/thin/hobbies'
import { ciAirsports } from '~/icons/source/thin/airsports'

// Solid icons
import { ciBigTruck } from '~/icons/source/solid/big-truck'
import { ciBicycle as ciBicycleSolid } from '~/icons/source/solid/bicycle'
import { ciBoats as ciBoatsSolid } from '~/icons/source/solid/boats'
import { ciBuses as ciBusesSolid } from '~/icons/source/solid/buses'
import { ciCamper } from '~/icons/source/solid/camper'
import { ciCars as ciCarsSolid } from '~/icons/source/solid/cars'
import { ciCaravans as ciCaravansSolid } from '~/icons/source/solid/caravans'
import { ciWheelLoaders as ciWheelLoadersSolid } from '~/icons/source/solid/wheel-loaders'
import { ciContainers as ciContainersSolid } from '~/icons/source/solid/containers'
import { ciAirsports as ciAirSportsSolid } from '~/icons/source/solid/airsports'
import { ciExcavator as ciExcavatorSolid } from '~/icons/source/solid/excavator'
import { ciForklifts as ciForkliftsSolid } from '~/icons/source/solid/forklifts'
import { ciGokarts as ciGokartsSolid } from '~/icons/source/solid/gokarts'
import { ciJobs as ciJobsSolid } from '~/icons/source/solid/jobs'
import { ciMotorbikes as ciMotorbikesSolid } from '~/icons/source/solid/motorbikes'
import { ciPartsAccessories as ciPartsAccessoriesSolid } from '~/icons/source/solid/parts-accessories'
import { ciHobbies as ciHobbiesSolid } from '~/icons/source/solid/hobbies'
import { ciRealEstate as ciRealEstateSolid } from '~/icons/source/solid/real-estate'
import { ciRentals as ciRentalsSolid } from '~/icons/source/solid/rentals'
import { ciSnowsports as ciSnowsportsSolid } from '~/icons/source/solid/snowsports'
import { ciTaxis as ciTaxisSolid } from '~/icons/source/solid/taxis'
import { ciTractors as ciTractorsSolid } from '~/icons/source/solid/tractors'
import { ciTrailers as ciTrailersSolid } from '~/icons/source/solid/trailers'
import { ciTrucks as ciTrucksSolid } from '~/icons/source/solid/trucks'
import { ciTruckTrailer } from '~/icons/source/solid/truck-trailer'
import { ciVans as ciVansSolid } from '~/icons/source/solid/vans'
import { ciWantedParts as ciWantedPartsSolid } from '~/icons/source/solid/wanted-parts'
import { ciWatersports as ciWatersportsSolid } from '~/icons/source/solid/watersports'
import { ciMarketplace as ciMarketplaceSolid } from '~/icons/source/solid/marketplace'
import { ciCabrio } from '~/icons/source/regular/cabrio'
import { ciLimoSedan } from '~/icons/source/regular/limo-sedan'
import { ciCompactHatchback } from '~/icons/source/regular/compact-hatchback'
import { ciCoupeSport } from '~/icons/source/regular/coupe-sport'
import { ciJeepSuv } from '~/icons/source/regular/jeep-suv'
import { ciCombiCaravan } from '~/icons/source/regular/combi-caravan'
import { ciVanMinibus } from '~/icons/source/regular/van-mini-bus'
import { ciPickup } from '~/icons/source/regular/pickup'
import { ciCommercialCar } from '~/icons/source/regular/commercial-car'
import { ciTrailerCar } from '~/icons/source/regular/trailer-car'
import { ciSportsCar } from '~/icons/source/regular/sports-car'
import { ciBicycle } from '~/icons/source/thin/bicycle'
import { ciAllMountainBike } from '~/icons/source/thin/all-mountain-bike'
import { ciBmxBike } from '~/icons/source/thin/bmx-bike'
import { ciDirtJumpBike } from '~/icons/source/thin/dirt-jump-bike'
import { ciDownhillBike } from '~/icons/source/thin/downhill-bike'
import { ciFatBike } from '~/icons/source/thin/fat-bike'
import { ciTrekkingBike } from '~/icons/source/thin/trekking-bike'
import { ciRacingBike } from '~/icons/source/thin/racing-bike'
import { ciRoadBike } from '~/icons/source/thin/road-bike'
import { ciCityBike } from '~/icons/source/thin/city-bike'
import { ciExpandedBike } from '~/icons/source/thin/expanded-bike'
import { ciThreeWheelBike } from '~/icons/source/thin/three-wheel-bike'
import { ciElectricBicycle } from '~/icons/source/thin/electric-bicycle'
import { ciCargoBike } from '~/icons/source/thin/cargo-bike'
import { ciDownhillEbike } from '~/icons/source/thin/downhill-ebike'
import { ciBicycleChildren } from '~/icons/source/thin/bicycle-children'
import { ciScooter } from '~/icons/source/thin/scooter'
import { ciRollers } from '~/icons/source/thin/rollers'
import { ciSkateboard } from '~/icons/source/thin/skateboard'
import { ciElectricScooter } from '~/icons/source/thin/electric-scooter'
import { ciKidScooter } from '~/icons/source/thin/kid-scooter'
import { ciSimpleScooter } from '~/icons/source/thin/simple-scooter'

// Solid icons only
export const categoriesSolidIconsMappings: {
  [categoryId: number]: CIcon
} = Object.freeze({
  [CategoryId.VEHICLES]: ciCarsSolid,
  [CategoryId.PARTS]: ciPartsAccessoriesSolid,
  [CategoryId.PLOT]: ciRealEstateSolid,
  [CategoryId.XYMA]: ciMarketplaceSolid,
  [CategoryId.JOBS]: ciJobsSolid,
  [CategoryId.RENTALS]: ciRentalsSolid,
  [CategoryId.DEALS]: ciDeals,
  [CategoryId.CARS]: ciCarsSolid,
  [CategoryId.BIKES]: ciMotorbikesSolid,
  [CategoryId.BOATS]: ciBoatsSolid,
  [CategoryId.COMMERCIAL]: ciTrucksSolid,
  [CategoryId.CAMPERS]: ciCaravansSolid,
  [CategoryId.BICYCLES]: ciBicycleSolid,
  [CategoryId.HOBBY]: ciHobbiesSolid,
  [CategoryId.PARTS_CARS]: ciCarsSolid,
  [CategoryId.PARTS_BIKES]: ciMotorbikesSolid,
  [CategoryId.PARTS_TRUCKS]: ciTrucksSolid,
  [CategoryId.PARTS_TRACTORS]: ciTractorsSolid,
  [CategoryId.PARTS_TOOLS]: ciPartsAccessoriesSolid,
  [CategoryId.PARTS_BOATS]: ciBoatsSolid,
  [CategoryId.PARTS_BICYCLES]: ciBicycleSolid,
  [CategoryId.PARTS_BUSES]: ciBusesSolid,
  [CategoryId.PARTS_BUILDERS]: ciExcavatorSolid,
  [CategoryId.PARTS_CAMPERS]: ciCaravansSolid,
  [CategoryId.PARTS_FORKLIFTS]: ciForkliftsSolid,
  [CategoryId.VANS]: ciVansSolid,
  [CategoryId.TRUCKS]: ciTrucksSolid,
  [CategoryId.BUSES]: ciBusesSolid,
  [CategoryId.BUILDERS]: ciExcavatorSolid,
  [CategoryId.SEMITRUCKS]: ciBigTruck,
  [CategoryId.SEMITRAILERS]: ciTruckTrailer,
  [CategoryId.TRACTORS]: ciTractorsSolid,
  [CategoryId.FORKLIFTS]: ciForkliftsSolid,
  [CategoryId.TRAILERS]: ciTrailersSolid,
  [CategoryId.TAXIS]: ciTaxisSolid,
  [CategoryId.CARAVANS]: ciCaravansSolid,
  [CategoryId.MOTORHOMES]: ciCamper,
  [CategoryId.CARAVANHOUSE]: ciWheelLoadersSolid,
  [CategoryId.CONTAINER]: ciContainersSolid,
  [CategoryId.RADIOCONTROLS]: ciHobbiesSolid,
  [CategoryId.GOKARTS]: ciGokartsSolid,
  [CategoryId.WATERSPORTS]: ciWatersportsSolid,
  [CategoryId.SNOWSPORTS]: ciSnowsportsSolid,
  [CategoryId.AIRSPORTS]: ciAirSportsSolid,
  [CategoryId.WANTED_PARTS]: ciWantedPartsSolid
})

export const categoriesIconsMappings: {
  [categoryId: number]: CIcon
} = Object.freeze({
  [CategoryId.XYMA]: ciMarketplace,
  [CategoryId.PLOT]: ciRealEstate,
  [CategoryId.PLOT_SALE]: ciSale,
  [CategoryId.PLOT_RENT]: ciRent,
  [CategoryId.PLOT_BOOKING]: ciBooking,
  [CategoryId.PLOT_WANTED_PROPERTY]: ciWantedProperty,
  [CategoryId.DEALS]: ciDeals,
  [CategoryId.JOBS]: ciJobs,
  [CategoryId.PARTS]: ciPartsAccessories,
  [CategoryId.CARS]: ciCars,
  [CategoryId.CARS_CABRIO]: ciCabrio,
  [CategoryId.CARS_LIMO]: ciLimoSedan,
  [CategoryId.CARS_COMPACT_HATCHBACK]: ciCompactHatchback,
  [CategoryId.CARS_COUPE_SPORT]: ciCoupeSport,
  [CategoryId.CARS_JEEP_SUV]: ciJeepSuv,
  [CategoryId.CARS_COMBI_CARAVAN]: ciCombiCaravan,
  [CategoryId.CARS_VAN_MINI_BUS]: ciVanMinibus,
  [CategoryId.CARS_PICKUP]: ciPickup,
  [CategoryId.CARS_COMMERCIAL]: ciCommercialCar,
  [CategoryId.CARS_TRAILER]: ciTrailerCar,
  [CategoryId.CARS_SPORTS_CAR]: ciSportsCar,
  [CategoryId.BICYCLES]: ciBicycles,
  [CategoryId.BICYCLE]: ciBicycle,
  [CategoryId.BICYCLE_ALL_MOUNTAIN]: ciAllMountainBike,
  [CategoryId.BICYCLE_BMX]: ciBmxBike,
  [CategoryId.BICYCLE_DIRT_JUMP]: ciDirtJumpBike,
  [CategoryId.BICYCLE_DOWNHILL]: ciDownhillBike,
  [CategoryId.BICYCLE_FAT]: ciFatBike,
  [CategoryId.BICYCLE_TREKKING]: ciTrekkingBike,
  [CategoryId.BICYCLE_RACING]: ciRacingBike,
  [CategoryId.BICYCLE_ROAD]: ciRoadBike,
  [CategoryId.BICYCLE_CITY]: ciCityBike,
  [CategoryId.BICYCLE_EXPANDABLE]: ciExpandedBike,
  [CategoryId.BICYCLE_THREE_WHEEL]: ciThreeWheelBike,
  [CategoryId.BICYCLE_ELECTRIC]: ciElectricBicycle,
  [CategoryId.BICYCLE_ELECTRIC_ALL_MOUNTAIN]: ciAllMountainBike,
  [CategoryId.BICYCLE_ELECTRIC_CARGO]: ciCargoBike,
  [CategoryId.BICYCLE_ELECTRIC_DOWNHILL]: ciDownhillEbike,
  [CategoryId.BICYCLE_ELECTRIC_FAT]: ciFatBike,
  [CategoryId.BICYCLE_ELECTRIC_TREKKING]: ciTrekkingBike,
  [CategoryId.BICYCLE_ELECTRIC_ROAD]: ciRoadBike,
  [CategoryId.BICYCLE_ELECTRIC_CITY]: ciCityBike,
  [CategoryId.BICYCLE_ELECTRIC_EXPANDABLE]: ciExpandedBike,
  [CategoryId.BICYCLE_CHILDREN]: ciBicycleChildren,
  [CategoryId.BICYCLE_CHILDREN_ALL_MOUNTAIN]: ciAllMountainBike,
  [CategoryId.BICYCLE_CHILDREN_BMX]: ciBmxBike,
  [CategoryId.BICYCLE_CHILDREN_CITY]: ciCityBike,
  [CategoryId.SCOOTER]: ciScooter,
  [CategoryId.SCOOTER_ROLLERS]: ciRollers,
  [CategoryId.SCOOTER_SKATEBOARD]: ciSkateboard,
  [CategoryId.SCOOTER_ELECTRIC]: ciElectricScooter,
  [CategoryId.SCOOTER_KIDS]: ciKidScooter,
  [CategoryId.SCOOTER_SIMPLE]: ciSimpleScooter,
  [CategoryId.VEHICLES]: ciVehicles,
  [CategoryId.BIKES]: ciMotorbikes,
  [CategoryId.BOATS]: ciBoats,
  [CategoryId.TRUCKS]: ciTrucks,
  [CategoryId.TRAILERS]: ciTrailers,
  [CategoryId.TAXIS]: ciTaxis,
  [CategoryId.CARAVANS]: ciCaravans,
  [CategoryId.MOTORHOMES]: ciMotorhomes,
  [CategoryId.RADIOCONTROLS]: ciHobbies,
  [CategoryId.GOKARTS]: ciGokarts,
  [CategoryId.WATERSPORTS]: ciWatersports,
  [CategoryId.SNOWSPORTS]: ciSnowsports,
  [CategoryId.AIRSPORTS]: ciAirsports,
  [CategoryId.VANS]: ciVans,
  [CategoryId.BUSES]: ciBuses,
  [CategoryId.BUILDERS]: ciBuilders,
  [CategoryId.SEMITRUCKS]: ciSemitrucks,
  [CategoryId.SEMITRAILERS]: ciSemitrailers,
  [CategoryId.TRACTORS]: ciTractors,
  [CategoryId.FORKLIFTS]: ciForklifts,
  [CategoryId.HOBBY]: ciHobbies,
  [CategoryId.COMMERCIAL]: ciTrucks,
  [CategoryId.CAMPERS]: ciCaravans,
  [CategoryId.RENTALS]: ciRentals,
  [CategoryId.PARTS_CARS]: ciCars,
  [CategoryId.PARTS_TRACTORS]: ciTractors,
  [CategoryId.PARTS_BUILDERS]: ciBuilders,
  [CategoryId.PARTS_TRUCKS]: ciTrucks,
  [CategoryId.PARTS_TOOLS]: ciPartsAccessories,
  [CategoryId.PARTS_FORKLIFTS]: ciForklifts,
  [CategoryId.PARTS_BUSES]: ciBuses,
  [CategoryId.PARTS_BIKES]: ciMotorbikes,
  [CategoryId.PARTS_BICYCLES]: ciBicycles,
  [CategoryId.PARTS_BOATS]: ciBoats,
  [CategoryId.PARTS_CAMPERS]: ciCaravans,
  [CategoryId.CARAVANHOUSE]: ciWheelLoaders,
  [CategoryId.CONTAINER]: ciContainers,
  [CategoryId.WANTED_PARTS]: ciWantedParts,
  [CategoryId.SERVICE]: ciCarService,
  [CategoryId.CATAMARAN]: ciCatamaran,
  [CategoryId.YATCH]: ciYacht,
  [CategoryId.JETSKI]: ciJetSki,
  [CategoryId.BOAT_PARKINKG]: ciBoatParking,
  [CategoryId.BOAT_FISHING]: ciFishingBoat,
  [CategoryId.SAILBOAT]: ciSailboat,
  [CategoryId.SPEEDBOAT]: ciSpeedboat,
  [CategoryId.BOAT_LICENSE]: ciBoatLicenses,
  [CategoryId.BOAT_FISHING_LICENSE]: ciBoatLicenses,
  [CategoryId.BOAT_OPEN]: ciBoatOpen,
  [CategoryId.BOAT_SMALL]: ciBoatRow,
  [CategoryId.BOAT_FERRY]: ciBoatFerry,
  [CategoryId.BOAT_TOURIST]: ciBoatTourist,
  [CategoryId.BOAT_CABIN]: ciCabinBoat,
  [CategoryId.BOAT_CANOE]: ciCanoeKayak,
  [CategoryId.BOAT_ENGINE]: ciBoatEngines,
  [CategoryId.BOAT_TOW]: ciBoatTug,
  [CategoryId.BOAT_TRAILER]: ciBoatTrailer,
  [CategoryId.BOAT_TRECHANDIRI]: ciFishingBoat,
  [CategoryId.BOAT_CARGO]: ciLoadShipper,
  [CategoryId.BOAT_INFLATABLE]: ciBoatInflatableRib,
  [CategoryId.RENTALS_CARS]: ciCars,
  [CategoryId.RENTALS_BIKES]: ciMotorbikes,
  [CategoryId.RENTALS_BOATS]: ciBoats,
  [CategoryId.RENTALS_COMMERCIALS]: ciTrucks,
  [CategoryId.RENTALS_CAMPERS]: ciCaravans,
  [CategoryId.RENTALS_BICYCLES]: ciBicycles,
  [CategoryId.RENTALS_HOBBY]: ciHobbies,
  [CategoryId.RENTALS_MISC]: ciThreeDots,
  [CategoryId.XYMA_TOOLS_ACCESSORIES]: ciToolsAccessories,
  [CategoryId.XYMA_CATERING_EQUIPMENT]: ciMassCateringEquipment,
  [CategoryId.XYMA_HEALTH_BEAUTY_MEDICINE]: ciHealthBeautyMedicine,
  [CategoryId.XYMA_BUSINESS_EQUIPMENT]: ciBusinessEquipment,
  [CategoryId.XYMA_ANTIQUES]: ciAntiques,
  [CategoryId.XYMA_HOBBY_SPORTS]: ciHobbySports,
  [CategoryId.XYMA_TECHNOLOGY_SECURITY]: ciTechnologySecurity,
  [CategoryId.XYMA_HOUSE_GARDEN]: ciHouseGarden,
  [CategoryId.XYMA_FASHION]: ciFashion,
  [CategoryId.XYMA_CHILDREN_GOODS]: ciChildrenGoods,
  [CategoryId.XYMA_PETS]: ciPetsAnimals,
  [CategoryId.XYMA_SUPERMARKET]: ciSupermarket
})
